import { useEffect, useState } from 'react';
import { useLoader } from 'src/provider/LoaderProvider';

// Aggregates every in-flight query/mutation flag for the page into one
// boolean and drives the global loader off of it.
export const useConfigurationLoadingState = (loadingFlags: boolean[]) => {
  const loader = useLoader();
  const [isLoading, setIsLoading] = useState(true);
  const isAnyLoading = loadingFlags.some(Boolean);

  useEffect(() => {
    setIsLoading(isAnyLoading);

    if (isAnyLoading) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isAnyLoading]);

  return isLoading;
};
